import { BRAND } from "./hmcConfig";
import { settings } from "./settings";
import { getTranslation } from "./translations";

import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import "/css/landingPopUp.scss";

library.add(faXmark);
dom.watch();

export const renderLandingPopUp = () => {
  if (settings.brand != BRAND.kenwood || !settings.landingPopUp) return;
  let html = `
  <div class="hmc-landing active">
    <div class="hmc-landing__wrapper">
        <div class="hmc-landing__box">
        <div class="hmc-landing__box--k"></div>
            <div class="hmc-landing__box--close"><button class="hmc-landing__box--close-btn hmc-landing-close"><i class="fa-solid fa-xmark"></i></button></div>
            <div class="hmc-landing__box__wrapper">
                <div class="hmc-landing__box--content">${getTranslation(
                  "hmc.landing.text"
                )}</div>
                <div><button class="hmc-landing__box--btn ken-button--primary hmc-landing-close">${getTranslation(
                  "hmc.landing.button"
                )}</button></div>
            </div>
        </div>
    </div>    
  </div>`;
  settings.app.header.insertAdjacentHTML("afterend", html);
  setCloseEvent();
};

const setCloseEvent = () => {
  document.querySelectorAll(`.hmc-landing-close`).forEach((element) => {
    element.addEventListener("click", closePopUp);
  });

  document.querySelectorAll(`.hmc-app__navigation__btn--next`).forEach((element) => {
    element.addEventListener("click", closePopUp);
  });
};

const closePopUp = () => {
  document.querySelector(".hmc-landing").classList.toggle('collapsed');
  setTimeout(() => {
    document.querySelector(".hmc-landing").classList.remove("active");
  }, 250);
};
